import { 
    Badge,
    Box, 
    Typography, 
    Button,
    IconButton,
    Tooltip,
    LinearProgress,
    CircularProgress 
} from '@mui/material';
import * as Icons from '@mui/icons-material';
import { useCurrentHashStore } from '../../stores/hashs/useCurrentHashStore';
import { useNotEscaletedLinesNextStore } from '../../stores/hashs/useNotEscaletedLinesNextStore';
import { notEscaletedLinesNextConfig } from '../../utils/hashs/hashConfig';
import { useLoadingStore, selectIsMainLoading } from '../../stores/useLoadingStore';
import ProfilesBtn from './ProfilesBtn';

export default function NotEscaletedLinesNextButton({ isCompactMode }) {

    const IconComponent = Icons[notEscaletedLinesNextConfig.icon] || Icons.Warning;

    const setCurrentHash = useCurrentHashStore(state => state.setCurrentHash);

    const currentHash = useCurrentHashStore(state => state.currentHash);

    const loading = useLoadingStore(state => state.loading);

    const loadProgress = useLoadingStore(state => state.loadProgress);

    const isMainLoading = useLoadingStore(selectIsMainLoading);

    const isActive = (currentHash === notEscaletedLinesNextConfig.hash);

    const insideVariant = (notEscaletedLinesNextConfig.variant === 'outlined' ? 'contained' : 'outlined');

    const data = useNotEscaletedLinesNextStore(state => state.data);
    const total = useNotEscaletedLinesNextStore(state => state.total);
    const totalDay = useNotEscaletedLinesNextStore(state => state.totalDay);
    const percentTotal = useNotEscaletedLinesNextStore(state => state.percentTotal);
    const title = useNotEscaletedLinesNextStore(state => state.title);    

    if (isCompactMode) {

        return (
            <Tooltip
                placement="right"
                arrow
                title={
                    <Box>
                        <Typography
                            variant="subtitle2"
                            fontWeight="bold"
                            mb={0.5}
                        >
                            {title}
                        </Typography>

                        <Typography variant="body2">
                            Linhas: <strong>{total}</strong>
                        </Typography>

                        <Typography variant="body2">
                            Total: <strong>{totalDay}</strong>
                        </Typography>

                        <Typography variant="body2">
                            Percentual: <strong>{percentTotal}%</strong>
                        </Typography>
                    </Box>
                }
            >
                <Box
                    sx={{
                        position: 'relative',
                        width: 48,
                        height: 48,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {isMainLoading && (
                        <CircularProgress
                            variant="determinate"
                            value={loadProgress ?? 0}
                            color={notEscaletedLinesNextConfig.color}
                            size={48}
                            thickness={3.5}
                            sx={{
                                position: 'absolute'
                            }}
                        />
                    )}

                    <Badge
                        badgeContent={total ?? 0}
                        max={99}
                        showZero
                        overlap="circular"
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        sx={{
                            overflow: 'visible',
                            zIndex: 2,

                            '& .MuiBadge-badge': {
                                backgroundColor:
                                    `${notEscaletedLinesNextConfig.color}.main`,

                                color:
                                    `${notEscaletedLinesNextConfig.color}.contrastText`,

                                fontSize: 9,
                                fontWeight: 700,
                                lineHeight: 1,

                                minWidth: 24,
                                height: 18,
                                padding: '0 4px',

                                borderRadius: 9,

                                border: '2px solid',
                                borderColor: 'background.paper',

                                boxShadow: 1,

                                top: 0,
                                right: 0,

                                transform:
                                    'translate(34%, -34%)',

                                transformOrigin:
                                    '100% 0%',

                                zIndex: 10
                            }
                        }}
                    >
                        <IconButton
                            color={notEscaletedLinesNextConfig.color}
                            disabled={loading}
                            onClick={() =>
                                setCurrentHash(
                                    notEscaletedLinesNextConfig.hash
                                )
                            }
                            sx={{
                                width: 40,
                                height: 40,

                                border: 2,
                                borderStyle: 'solid',
                                borderColor:
                                    `${notEscaletedLinesNextConfig.color}.main`,

                                bgcolor: isActive
                                    ? `${notEscaletedLinesNextConfig.color}.main`
                                    : 'background.paper',

                                color: isActive
                                    ? `${notEscaletedLinesNextConfig.color}.contrastText`
                                    : `${notEscaletedLinesNextConfig.color}.main`,

                                boxShadow: 2,

                                transform: isActive
                                    ? 'scale(1.08)'
                                    : 'scale(1)',

                                transition:
                                    'all 0.2s ease-in-out',

                                '&:hover': {
                                    bgcolor:
                                        `${notEscaletedLinesNextConfig.color}.main`,

                                    color:
                                        `${notEscaletedLinesNextConfig.color}.contrastText`,

                                    transform: 'scale(1.08)'
                                }
                            }}
                        >
                            <IconComponent
                                sx={{
                                    fontSize: 27
                                }}
                            />
                        </IconButton>
                    </Badge>
                </Box>
            </Tooltip>
        );

    }

    return (
        <Button
            sx={{
                borderRadius: 1,
                paddingX: 1.5,
                display: 'flex',
                flexDirection: 'column',
                flexBasis: {
                    xs: '100%',
                    md: notEscaletedLinesNextConfig.width,
                },
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                textAlign: 'left',
                position: 'relative',

                borderWidth:
                    insideVariant === 'outlined' ? 3 : 0,
                borderStyle:
                    insideVariant === 'outlined'  ? 'solid' : 'none',

                transform: isActive ? 'scale(1.05)' : 'scale(1)',
                transition: 'transform 0.2s ease-in-out',
                transformOrigin: 'center center'
            }}
            variant={insideVariant}
            color={notEscaletedLinesNextConfig.color}
            loading={loading}
            onClick={() => setCurrentHash(notEscaletedLinesNextConfig.hash)}
        >

            {/* PROGRESSO */}
            {isMainLoading && (
                <LinearProgress
                    variant="determinate"
                    value={loadProgress ?? 0}
                    color={notEscaletedLinesNextConfig.color}
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                        height: 4
                    }}
                />
            )}        
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    gap: .5,
                    alignItems: 'center',
                    marginBottom: 1
                }}
            >
                <IconComponent sx={{ fontSize: 24 }} />
                <Typography variant="body2">
                    <strong>{title}</strong>
                </Typography>
            </Box>

            <ProfilesBtn
                data={data}
                total={total}
            />
            
            {!isMainLoading && (
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingTop: 1,
                        borderTop: 2,
                        marginTop: 1,
                        gap: 0
                    }}
                >
                    <Box
                        sx={{
                            px: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 0
                        }}
                    >
                        <Typography variant="h4" fontWeight="300">{total}</Typography>
                        <Typography sx={{marginTop: -1}} variant="subtitle2" fontWeight="300">Total: {totalDay}</Typography>
                    </Box> 
                    <Typography variant="h6">({percentTotal}%)</Typography>               
                </Box>
            )}
        </Button>
    );

}